module.exports = __webpack_public_path__ + "static/media/xiaojun-3.jpeg";